var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.789 59.7894C119.789 67.6687 118.237 75.4708 115.222 82.7503C112.207 90.0299 107.787 96.6442 102.216 102.216C96.6441 107.787 90.0298 112.207 82.7503 115.222C75.4707 118.237 67.6686 119.789 59.7893 119.789V59.7894H119.789Z",
    fill: "#FEB449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.789 0C119.789 7.8793 118.237 15.6814 115.222 22.961C112.207 30.2405 107.787 36.8548 102.216 42.4263C96.6441 47.9978 90.0298 52.4174 82.7503 55.4327C75.4707 58.448 67.6686 59.9999 59.7893 59.9999V0H119.789Z",
    fill: "#79C3AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 119.789C180 111.91 178.448 104.108 175.433 96.8282C172.418 89.5487 167.998 82.9343 162.427 77.3628C156.855 71.7913 150.241 67.3718 142.961 64.3565C135.682 61.3412 127.88 59.7893 120 59.7893V119.789H180Z",
    fill: "#FEB449"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.67029e-05 59.7894C-2.67029e-05 67.6687 1.55192 75.4708 4.5672 82.7503C7.58247 90.0299 12.002 96.6442 17.5735 102.216C23.1451 107.787 29.7594 112.207 37.0389 115.222C44.3184 118.237 52.1206 119.789 59.9999 119.789V59.7894H-2.67029e-05Z",
    fill: "#FEB449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.02cc4b513b470bc6176cc902252422b2.svg";
export { ForwardRef as ReactComponent };